<template>
  <div>
    <div class="hs-code__empty-state" v-if="isLoading">
      <font-awesome-icon :icon="['fas', 'spinner-third']" class="fa-spin" />
      {{ $t("Loading") }}...
    </div>
    <div class="hs-code__empty-state" v-else-if="isError">
      <font-awesome-icon :icon="['fas', 'exclamation-circle']" />
      We could not load the {{ type }}. Please try again later.
    </div>
  </div>
</template>

<script>
export default {
  name: "LoadingErrorState",
  props: ["isError", "isLoading", "type"],
};
</script>

<style scoped>
.hs-code__empty-state {
  padding: 50px;
  text-align: center;
}

.hs-code__empty-state svg {
  margin-right: 10px;
}

.hs-code__loading-icon {
  display: inline-block;
  margin-right: 15px;
}
</style>
